import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../../../components/AppShell/styles";

const MOBILE = `not all and (min-width: ${DESKTOP_BREAKPOINT})`;

export const Container = styled.div`
  /* Room for the fixed subscribe bar */
  padding-bottom: 8rem;

  .plus-cta {
    padding: 0.875rem 1.5rem;
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    font-weight: 800;
    color: var(--color-neutral-darkness);
    background: var(--color-brand-plus);
    border-radius: 100px;
    transition:
      filter 0.15s,
      opacity 0.15s;

    &:hover:not(:disabled) {
      filter: brightness(1.08);
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.5rem 2rem 0;

  @media ${MOBILE} {
    padding: 20px 20px 0;
  }

  .help {
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: var(--color-neutral-150);
  }
`;

/* The chosen plan, with the green glow of the other PLUS blocks in one compact row (its price is in the subscribe bar) */
export const PlanSummary = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  padding: 0.75rem 1rem;
  background:
    radial-gradient(120% 140% at 0% 0%, rgba(87, 242, 139, 0.18) 0%, rgba(87, 242, 139, 0) 60%),
    var(--color-neutral-dark);
  border-radius: 12px;
  box-shadow: inset 0 0 0 1px rgba(87, 242, 139, 0.25);

  .plan {
    min-width: 0;
    overflow: hidden;
    font-family: Inter, sans-serif;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: var(--color-neutral-150);

    strong {
      font-weight: 800;
      color: var(--color-neutral-white);
    }
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
`;

/* The "+" of the "create a new Keepo" choice, same as the Keepos list's */
export const NewIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  color: var(--color-neutral-150);
  background: var(--color-neutral-dark);
  border-radius: 100%;
`;
